module.exports = __webpack_public_path__ + "static/media/DeleteRed.211e15c8.svg";